import PropTypes from 'prop-types';
import {BackButton, ProgressIndicator} from '@/components/atoms';
import {PageHeader, SaveCancelFooter} from '@/components/molecules';
import {getPerfectStoreStepConfig} from '@/utils/perfectStoreStepConfig';

const stepConfig = getPerfectStoreStepConfig();

const PerfectStoreWizardLayout = ({
  currentStep,
  title,
  onStepClick,
  children,
  FormError,
  handleCancel,
  draftAction,
  nextAction,
  disableDraft = false,
  hideSaveDraft = false,
  nextButtonTitle,
  isReview = false,
  beforeBack
}) => {
  return (
    <div className='perfectStoreWizard' data-testid='perfect-store-wizard'>
      <BackButton id='perfect-store-back' beforeBack={beforeBack} />
      <PageHeader title={title} />
      <ProgressIndicator
        currentStep={currentStep}
        completed={false}
        orientation='horizontal'
        steps={stepConfig.steps}
        titles={stepConfig.titles}
        className='mb-6'
        onStepClick={onStepClick}
      />
      <br />
      {children}
      <SaveCancelFooter
        FormError={FormError}
        handleCancel={handleCancel}
        draftAction={draftAction}
        nextAction={nextAction}
        disableDraft={disableDraft}
        hideSaveDraft={hideSaveDraft}
        nextButtonTitle={nextButtonTitle}
        isReview={isReview}
      />
    </div>
  );
};

PerfectStoreWizardLayout.propTypes = {
  currentStep: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onStepClick: PropTypes.func,
  children: PropTypes.node,
  FormError: PropTypes.bool,
  handleCancel: PropTypes.func.isRequired,
  draftAction: PropTypes.func.isRequired,
  nextAction: PropTypes.func.isRequired,
  disableDraft: PropTypes.bool,
  hideSaveDraft: PropTypes.bool,
  nextButtonTitle: PropTypes.string,
  isReview: PropTypes.bool,
  beforeBack: PropTypes.func
};

export default PerfectStoreWizardLayout;
